import { AiChoiceListGenerationButton } from './AiChoiceListGenerationButton';
import { AiChoiceListGenerationOverlay } from './AiChoiceListGenerationOverlay';

export const AiChoiceListGeneration = {
  Button: AiChoiceListGenerationButton,
  Overlay: AiChoiceListGenerationOverlay,
};
